import {
  Component,
  OnInit,
  Inject,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { ModalBasicoComponent } from "../modal-basico/modal-basico.component";
import { User } from "src/app/models/user";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { UserService } from "src/app/services/user.service";
import { Router } from "@angular/router";
import { InstituicaoService } from "src/app/services/instituicao.service";
import { TipoInscricaoService } from "src/app/services/tipo-inscricao.service";
import { HttpClient } from "@angular/common/http";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { EventEmitter } from "@angular/core";
import util from "../../../util";
declare var paypal;
import { environment } from 'src/environments/environment';
@Component({
  selector: "app-modal-historico",
  templateUrl: "./modal-historico.component.html",
  styleUrls: ["./modal-historico.component.scss"],
})
export class ModalHistoricoComponent implements OnInit {
  @ViewChild("paypal", { static: true }) paypalElement: ElementRef;
  visible: boolean = false;
  urlAPI = util.api; // api rest fake
  paypalScriptLoaded = false;
  paypalLoadingPromise: Promise<void> | null = null;
  private paypalRenderAttempts = 0;
  constructor(
    public dialogRef: MatDialogRef<ModalBasicoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private cd: ChangeDetectorRef,
    private httpClient: HttpClient,
    public dialog: MatDialog
  ) {}
  onAdd = new EventEmitter();
  emailFormControl = new FormControl("", [
    Validators.required,
    Validators.email,
  ]);
  senhaFormControl = new FormControl("", [Validators.required]);

  ngOnInit() {
    this.paypalLoadingPromise = this.loadPayPalScript("BRL");
    this.paypalLoadingPromise
      .then(() => {
        setTimeout(() => this.initConfig(), 100);
      })
      .catch(() => {
        console.error("Falha ao carregar PayPal SDK no modal-historico.");
      });
  }
  loadPayPalScript(currency: string = "BRL"): Promise<void> {
    const win: any = window;
    if (win.__paypalLoaderPromise) {
      return win.__paypalLoaderPromise;
    }
    if (typeof win.paypal !== "undefined") {
      win.__paypalLoaderPromise = Promise.resolve();
      this.paypalScriptLoaded = true;
      return win.__paypalLoaderPromise;
    }

    win.__paypalLoaderPromise = new Promise((resolve, reject) => {
      try {
        const script = document.createElement("script");
        script.src =
          "https://www.paypal.com/sdk/js?client-id=" +
          environment.paypalClientId +
          "&currency=" +
          encodeURIComponent(currency) +
          "&locale=pt_BR";

        script.onload = () => {
          this.paypalScriptLoaded = true;
          resolve();
        };
        script.onerror = (ev) => {
          console.error("Falha ao carregar PayPal SDK", ev);
          reject(ev);
        };

        document.body.appendChild(script);
      } catch (err) {
        reject(err);
      }
    });
    return win.__paypalLoaderPromise;
  }
  initConfig() {
    const self = this;
    const win: any = window;
    if (!paypal || !paypal.Buttons) {
      console.error("PayPal Buttons não disponível no initConfig do modal-historico");
      return;
    }

    // Always create a dedicated container for the buttons per modal.
    // We keep a single SDK loader but create one Buttons instance per component/modal
    // so multiple modals can show PayPal buttons concurrently.

    // create a dedicated container for the buttons and save globally after render
    const btnContainer = document.createElement('div');
    this.paypalElement.nativeElement.innerHTML = '';
    this.paypalElement.nativeElement.appendChild(btnContainer);

    const buttons = paypal.Buttons({
        createOrder: (data, actions) => {
          // pass in any options from the v2 orders create call:
          // https://developer.paypal.com/api/orders/v2/#orders-create-request-body
          const createOrderPayload = {
            purchase_units: [
              {
                amount: {
                  currency_code: "BRL",
                  value: self.data.valor,
                },
                description: `Associação SBCAT ao ano ${this.data.ano.toString()}`, 

              },
            ],
            intent: "CAPTURE",
          };

          return actions.order.create(createOrderPayload);
        },

        // finalize the transaction
        onApprove: (data, actions) => {
          const captureOrderHandler = (details) => {
            const payerName = details.payer.name.given_name;
            this.salvarPagamentoPaypal();

          };

          return actions.order.capture().then(captureOrderHandler);
        },

        // handle unrecoverable errors
        onError: (err) => {
          console.error(
            "An error prevented the buyer from checking out with PayPal"
          );
        },
      });

    buttons
      .render(btnContainer)
      .catch((err) => {
        console.error('Erro ao renderizar PayPal Buttons no modal-historico', err);
      });
  }
  salvarPagamentoPaypal() {
    let env = {
      usuarioId: this.data.id_usuario,
      valor: this.data.valor,
      tInscri: this.data.tipo_usuario,
      nome: this.data.nome,
      email: this.data.email,
      ano: this.data.ano.toString(),
      ano_anuidade: this.data.ano.toString(),
    };
    this.httpClient
      .post(this.urlAPI + "pagar/paypal", env, { observe: "response" })
      .subscribe((r) => {
        this.visible = true;
        if (r.status === 200) {
          let url: any = r.body;
          let modal = this.dialog.open(ModalBasicoComponent, {
            width: "33vw",
            data: {
              mnsg: "Pagamento Realizado com succeso",
              buttonOK: true,
              buttonCancelar: false,
            },
          });
          modal.componentInstance.onAdd.subscribe(() => {
            this.dialogRef.close();
            this.visible = true;
            this.router.navigate(["/Main/Home"]);
          });
          modal.afterClosed().subscribe((result) => {
            this.dialogRef.close();
            this.visible = true;
            this.router.navigate(["/Main/Home"]);
          });
        }

      });
  }
  onNoClick(): void {
    this.onAdd.emit();
    this.dialogRef.close();
  }
  cancelar() {
    this.dialogRef.close();
  }
  pagamentopagseguro() {
    this.visible = false;
    let env = {
      usuarioId: this.data.id_usuario,
      valor: this.data.valor,
      tInscri: this.data.tipo_usuario,
      nome: this.data.nome,
      email: this.data.email,
      ano: this.data.ano.toString(),
      ano_anuidade: this.data.ano.toString(),
    };

    this.httpClient
      .post(this.urlAPI + "pagseguro/credencias", env, { observe: "response" })
      .subscribe((r) => {
        this.dialogRef.close();
        this.visible = true;
        if (r.status === 200) {
          let url: any = r.body;
          window.open(url.url);
          this.router.navigate(["/Main/Home"]);
        }

      });
  }
   async openDialog() {

    let mnsg =
      "Para concluir sua associação você será redirecionado ao PagSeguro";
    let modal = this.dialog.open(ModalBasicoComponent, {
      // width: "33vw",
      data: { mnsg: mnsg, buttonOK: true, buttonCancelar: true },
    });
    modal.componentInstance.onAdd.subscribe(() => {
      this.pagamentopagseguro();
      // this.router.navigate(['/Main/Home']);
    });
  }
}
